import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

const ProgressContext = createContext({
  isAnimating: false
});

export const ProgressProvider = (props) => {
  const { children } = props;
  const [isAnimating, setAnimating] = useState(false);

  return (
    <ProgressContext.Provider
      value={{
        isAnimating,
        setLoading: setAnimating
      }}
      {...props}
    >
      {children}
    </ProgressContext.Provider>
  );
};

ProgressProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default ProgressContext;
